<template>
  <b-card>
    <b-button
      type="button"
      class="back-btn flex items-center mb-4"
      @click="showProfile"
    >
      <feather-icon icon="ChevronLeftIcon" svgClasses="" @click="showProfile" />
      Back
    </b-button>
    <h2 class="text-2xl font-semibold">Session Details</h2>
    <div class="pt-4">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="srno" label="Sr.no" width="180">
        </el-table-column>
        <el-table-column
          prop="servicepn"
          label="Service Provider Name"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="service" label="Service" width="180">
        </el-table-column>
        <el-table-column prop="date" label="Date" width="180">
        </el-table-column>
        <el-table-column prop="phone" label="Phone" width="180">
        </el-table-column>
        <el-table-column prop="email" label="Email " width="180">
        </el-table-column>
        <el-table-column prop="time" label="Time"> </el-table-column>
      </el-table>
    </div>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        @change="handlePageChange"
        v-model="currentPage"
        :per-page="10"
      ></base-pagination>
      <!-- <b-pagination
        @change="handlePageChange"
        pills
        v-model="currentPage"
        :total-rows="total_row"
        :per-page="perPage"
        size="lg"
        class="ml-auto flex flex-wrap"
      ></b-pagination> -->
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  data() {
    return {
      // CategoryData,

      tableData: [
        {
          srno: "1",
          servicepn: "gsdg",
          service: "Familly",
          date: "2016-05-03",
          phone: "6549418918",
          email: "xyz.@gmail.com",
          time: "04/01/2024",
        },
        {
          srno: "2",
          servicepn: "gsdg",
          service: "Familly",
          date: "2016-05-03",
          phone: "6549418918",
          email: "xyz.@gmail.com",
          time: "04/01/2024",
        },
        {
          srno: "3",
          servicepn: "gsdg",
          service: "Familly",
          date: "2016-05-03",
          phone: "6549418918",
          email: "xyz.@gmail.com",
          time: "04/01/2024",
        },
        {
          srno: "4",
          servicepn: "gsdg",
          service: "Familly",
          date: "2016-05-03",
          phone: "6549418918",
          email: "xyz.@gmail.com",
          time: "04/01/2024",
        },
      ],
    };
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,

    // ViewProfile,
  },
  methods: {
    showProfile() {
      this.$router.push({ name: "admin-user" });
    },
  },
};
</script>
